import { render } from "./Lock.vue?vue&type=template&id=12e6b3b9"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Lock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12e6b3b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12e6b3b9', __exports__)) {
    api.reload('12e6b3b9', __exports__)
  }
  
  module.hot.accept("./Lock.vue?vue&type=template&id=12e6b3b9", () => {
    api.rerender('12e6b3b9', render)
  })

}


export default __exports__